import {css} from '@emotion/react'
import normalizeUrl from '@/biz/normalizeUrl.mjs'
import {FileList} from '@/components/File/index.mjs'
import {useAiContext} from './AiContext.mjs'
import srcAvatar from './ai-avatar.png'
import {ResponseBody as DefaultResponseBody} from './ResponseBody.jsx'
import {Markdown} from './Markdown/Markdown.jsx'

const cssAvatar = css({
    gridRow: '1 / 3',
    width: 24,
    height: 24,
    borderRadius: '50%',
    outline: '1px solid #d5e4ff',
    outlineOffset: 4,
    margin: 5,
})

const Avatar = () => {
    const ai = useAiContext()

    if (ai.compactView) {
        return null
    }

    return (
        <img
            css={cssAvatar}
            src={srcAvatar}
        />
    )
}

const cssAiMessage = css({
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gap: 8,
})

const cssAiMessageCompact = css({
    gridTemplateColumns: '1fr',
})

const cssResponse = css({
    userSelect: 'text',
})

const cssAnswer = css({
    width: '100%',
})

const cssError = css({
    backgroundColor: '#faeff3',
    whiteSpace: 'pre-wrap',
    padding: 12,
    borderRadius: 12,
})

const cssErrorCompact = css({
    padding: 8,
    borderRadius: 8,
})

export const ErrorMessage = ({message, ...props}) => {
    const ai = useAiContext()
    const {content} = message

    if (! content) {
        return null
    }

    return (
        <div
            css={[cssAiMessage, ai.compactView && cssAiMessageCompact]}
            {...props}
        >
            <Avatar />

            <div css={cssResponse}>
                <Markdown css={[
                    cssAnswer,
                    cssError,
                    ai.compactView && cssErrorCompact
                ]}>
                    {content}
                </Markdown>
            </div>
        </div>
    )
}

export const ResponseMessage = ({message, ...props}) => {
    const ai = useAiContext()
    const {content, files = [], status} = message

    if (! content && (! status || 'aborted' === status)) {
        return null
    }

    const ResponseBody = ai.ResponseBody ?? DefaultResponseBody

    const _files = files.map(f => {
        const {fileId, len: size, originalFileName: name} = f
        const src = normalizeUrl(`/files/${fileId}`)
        return {name, size, src}
    })

    return (
        <div
            css={[cssAiMessage, ai.compactView && cssAiMessageCompact]}
            {...props}
        >
            <Avatar />

            <ResponseBody
                css={cssResponse}
                message={message}
            />

            <FileList files={_files} />
        </div>
    )
}
